


































































































































import Vue, { PropType } from 'vue';
import ProfileImagePreview from './components/ProfileImagePreview.vue';
import { CvSectionProfileSexEnum } from '@/../gen';
import { serializeDate } from '@/utils/date';
import { DATE_SEPARATOR_IN_FORM } from '@/utils/constants';
import { i18n, i18nHints } from '@/plugins/i18n';
import AvatarInput from '@/components/AvatarInput.vue';

export interface FormDataInterface {
  profile_image?: string;
  remove_profile_image?: boolean;
  full_name?: string;
  birthday?: string;
  sex?: CvSectionProfileSexEnum;
  email?: string;
  phone_number?: string;
  location?: string;
  headline?: string;
  website_url?: string;
}

export default Vue.extend({
  components: {
    AvatarInput,
    ProfileImagePreview,
  },
  props: {
    section: {
      // FIXME update generated format
      // type: Object as () => CvSectionProfile,
      type: Object as PropType<any>,
      required: true,
    },
  },
  data() {
    const {
      full_name,
      birthday_year,
      birthday_month,
      birthday_day,
      profile_image,
      sex,
      email,
      phone_number,
      location,
      headline,
      website_url,
    } = this.section;
    return {
      formData: {
        profile_image,
        remove_profile_image: false,
        full_name,
        birthday: serializeDate(
          {
            year: birthday_year,
            month: birthday_month,
            day: birthday_day,
          },
          DATE_SEPARATOR_IN_FORM
        ),
        sex: sex || CvSectionProfileSexEnum.NotKnown,
        email,
        phone_number,
        location,
        headline,
        website_url,
      } as FormDataInterface,
    };
  },
  computed: {
    sexOptions: (): Option[] => {
      const makeOption = sex => {
        return {
          value: sex,
          text: i18n.tc(i18nHints.models.cv_section_profile.sexes[sex]),
        };
      };
      return [
        makeOption(CvSectionProfileSexEnum.NotKnown),
        makeOption(CvSectionProfileSexEnum.Male),
        makeOption(CvSectionProfileSexEnum.Female),
        makeOption(CvSectionProfileSexEnum.NotApplicable),
      ];
    },
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.formData);
    },
    onCancel() {
      this.$emit('cancel');
    },
    onChangeProfileImage({
      profile_image,
      remove_profile_image,
    }: {
      profile_image: File;
      remove_profile_image: boolean;
    }) {
      this.formData.profile_image = profile_image;
      this.formData.remove_profile_image = remove_profile_image;
    },
  },
});
